import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { readAvailable27gpepp0hyyts as readAvailable } from './core/Input.mjs';
import { BytePacketBuilder2biodf4wxvlba as BytePacketBuilder } from './core/BytePacketBuilder.mjs';
import { readBytesj5m5qe40si0k as readBytes } from './core/Buffers.mjs';
import {
  get_remaining1lapv95kcmm0y as get_remaining,
  discard3ugntd47xyll6 as discard,
} from './core/ByteReadPacket.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { close3semq7pafb42g as close } from './ByteWriteChannelOperations.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { ByteChannelScanner1h148q1m3y1ey as ByteChannelScanner } from './ByteChannelScanner.mjs';
import {
  LineEnding_Default_getInstance3rv7nlgborrds as LineEnding_Default_getInstance,
  LineEnding_Lenient_getInstanceagvw5ljm3cic as LineEnding_Lenient_getInstance,
} from './LineEnding.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { readByteString2hnsbql6t4ads as readByteString } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/ByteStrings.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { TooLongLineException2d6ls946t46wx as TooLongLineException } from './charsets/Encoding.mjs';
import { readString3v6duspiz33tv as readString } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_readBuffer__s1sw5u(_this__u8e3s4, $completion) {
  var result = new (Buffer())();
  while (!_this__u8e3s4.o4j()) {
    result.h4g(_this__u8e3s4.h4j());
    var tmp = _this__u8e3s4.q4j(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var tmp0_safe_receiver = _this__u8e3s4.m4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return result;
}
function readBuffer(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBuffer__s1sw5u.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readAvailable__ki7w73(_this__u8e3s4, buffer, offset, length, $completion) {
  if (_this__u8e3s4.o4j())
    return -1;
  if (_this__u8e3s4.h4j().z3x()) {
    var tmp = _this__u8e3s4.q4j(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  if (_this__u8e3s4.o4j())
    return -1;
  return readAvailable(_this__u8e3s4.h4j(), buffer, offset, length);
}
function readAvailable_0(_this__u8e3s4, buffer, offset, length, $completion) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAvailable__ki7w73.bind(VOID, _this__u8e3s4, buffer, offset, length), $completion);
}
function *_generator_readRemaining__kd4xx0(_this__u8e3s4, $completion) {
  var result = BytePacketBuilder();
  while (!_this__u8e3s4.o4j()) {
    result.h4g(_this__u8e3s4.h4j());
    var tmp = _this__u8e3s4.q4j(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  rethrowCloseCauseIfNeeded_0(_this__u8e3s4);
  return result.y3x();
}
function readRemaining(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readRemaining__kd4xx0.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_toByteArray__v3q9dq(_this__u8e3s4, $completion) {
  var tmp = readBuffer(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return readBytes(tmp);
}
function toByteArray(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toByteArray__v3q9dq.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_copyTo__iu4794(_this__u8e3s4, channel, limit, $completion) {
  var remaining = limit;
  try {
    while (!_this__u8e3s4.o4j() && remaining > 0n) {
      if (_this__u8e3s4.h4j().z3x()) {
        var tmp = _this__u8e3s4.q4j(VOID, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0 = remaining;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = get_remaining(_this__u8e3s4.h4j());
      var count = tmp0 <= b ? tmp0 : b;
      _this__u8e3s4.h4j().u4f(channel.k4j(), count);
      remaining = subtract(remaining, count);
      var tmp_0 = channel.v4i($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      _this__u8e3s4.s4j(cause);
      close(channel, cause);
      throw cause;
    } else {
      throw $p;
    }
  }
  finally {
    var tmp_1 = channel.v4i($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return subtract(limit, remaining);
}
function copyTo(_this__u8e3s4, channel, limit, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_copyTo__iu4794.bind(VOID, _this__u8e3s4, channel, limit), $completion);
}
function *_generator_discard__skcevq(_this__u8e3s4, max, $completion) {
  var remaining = max;
  while (remaining > 0n && !_this__u8e3s4.o4j()) {
    if (get_availableForRead(_this__u8e3s4) === 0) {
      var tmp = _this__u8e3s4.q4j(VOID, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    var tmp0 = remaining;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(_this__u8e3s4.h4j());
    var count = tmp0 <= b ? tmp0 : b;
    discard(_this__u8e3s4.h4j(), count);
    remaining = subtract(remaining, count);
  }
  return subtract(max, remaining);
}
function discard_0(_this__u8e3s4, max, $completion) {
  max = max === VOID ? 9223372036854775807n : max;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_discard__skcevq.bind(VOID, _this__u8e3s4, max), $completion);
}
function *_generator_skipIfFound__8uzshe(_this__u8e3s4, byteString, $completion) {
  var tmp = peek(_this__u8e3s4, byteString.v2(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (equals(tmp, byteString)) {
    var tmp_0 = discard_0(_this__u8e3s4, fromInt(byteString.v2()), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return true;
  }
  return false;
}
function skipIfFound(_this__u8e3s4, byteString, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_skipIfFound__8uzshe.bind(VOID, _this__u8e3s4, byteString), $completion);
}
function *_generator_readPacket__axk2oa(_this__u8e3s4, packet, $completion) {
  var result = new (Buffer())();
  $l$loop: while (result.v2() < fromInt(packet)) {
    if (_this__u8e3s4.h4j().z3x()) {
      var tmp = _this__u8e3s4.q4j(VOID, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    if (_this__u8e3s4.o4j())
      break $l$loop;
    if (get_remaining(_this__u8e3s4.h4j()) > subtract(numberToLong(packet), result.v2())) {
      _this__u8e3s4.h4j().u4f(result, subtract(numberToLong(packet), result.v2()));
    } else {
      _this__u8e3s4.h4j().v4f(result);
    }
  }
  if (result.v2() < fromInt(packet)) {
    throw EOFException().x4e('Not enough data available, required ' + packet + ' bytes but only ' + result.v2().toString() + ' available');
  }
  return result;
}
function readPacket(_this__u8e3s4, packet, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readPacket__axk2oa.bind(VOID, _this__u8e3s4, packet), $completion);
}
function readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
  return (new (ByteChannelScanner())(_this__u8e3s4, matchString, writeChannel, limit)).c4k(ignoreMissing, $completion);
}
function readLineStrictTo(_this__u8e3s4, out, limit, lineEnding, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
  // Inline function 'kotlin.require' call
  if (!(limit >= 0n)) {
    var message = 'Limit (' + limit.toString() + ') should be non-negative';
    throw IllegalArgumentException().s2(toString(message));
  }
  return internalReadLineTo(_this__u8e3s4, out, limit, lineEnding.equals(LineEnding_Lenient_getInstance()), true, $completion);
}
function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.m4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.m4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function get_availableForRead(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.h4j().y3x().v2());
}
function *_generator_peek__qjkkqb(_this__u8e3s4, count, $completion) {
  if (_this__u8e3s4.o4j())
    return null;
  var tmp = _this__u8e3s4.p4j(count, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return null;
  return readByteString(_this__u8e3s4.h4j().d40(), count);
}
function peek(_this__u8e3s4, count, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_peek__qjkkqb.bind(VOID, _this__u8e3s4, count), $completion);
}
function *_generator_internalReadLineTo__5n8dpi(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion) {
  var readBuffer = _this__u8e3s4.h4j();
  if (readBuffer.z3x()) {
    var tmp = _this__u8e3s4.q4j(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  if (_this__u8e3s4.o4j())
    return -1n;
  var consumed = {_v: 0n};
  $l$loop: while (consumed._v < limit && !_this__u8e3s4.o4j()) {
    var limitLeft = subtract(limit, consumed._v);
    var lfIndex = indexOf(readBuffer, 10, VOID, limitLeft);
    var crIndex = internalReadLineTo$scanForSoleCr(readBuffer, lenientLineEnding, lfIndex, limitLeft);
    if (crIndex >= 0n) {
      internalReadLineTo$transferString(readBuffer, out, consumed, crIndex);
      discard(readBuffer, 1n);
      return consumed._v;
    }
    if (lfIndex === 0n) {
      discard(readBuffer, 1n);
      return consumed._v;
    }
    if (lfIndex > 0n) {
      var tmp_0;
      var tmp_1 = readBuffer.y3x();
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$0 = subtract(lfIndex, fromInt(1));
      if (tmp_1.v3w(tmp$ret$0) === 13) {
        tmp_0 = 1n;
      } else {
        tmp_0 = 0n;
      }
      var isCrlf = tmp_0;
      internalReadLineTo$transferString(readBuffer, out, consumed, subtract(lfIndex, isCrlf));
      discard(readBuffer, add(numberToLong(1), isCrlf));
      return consumed._v;
    }
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(readBuffer);
    var count = limitLeft <= b ? limitLeft : b;
    var tmp_2 = readBuffer.y3x();
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$2 = subtract(count, fromInt(1));
    if (tmp_2.v3w(tmp$ret$2) === 13) {
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$3 = subtract(count, fromInt(1));
      internalReadLineTo$transferString(readBuffer, out, consumed, tmp$ret$3);
      var tmp_3 = internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      if (tmp_3)
        return consumed._v;
      internalReadLineTo$transferString(readBuffer, out, consumed, 1n);
    } else {
      internalReadLineTo$transferString(readBuffer, out, consumed, count);
    }
    var tmp_4;
    if (consumed._v < limit && get_remaining(readBuffer) === 0n) {
      var tmp_5 = _this__u8e3s4.q4j(VOID, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      tmp_4 = !tmp_5;
    } else {
      tmp_4 = false;
    }
    if (tmp_4)
      break $l$loop;
  }
  if (consumed._v === 0n && _this__u8e3s4.o4j())
    return -1n;
  // Inline function 'kotlin.check' call
  if (!(consumed._v <= limit)) {
    var message = 'Consumed bytes exceed the limit: ' + consumed._v.toString() + ' > ' + limit.toString() + ". It's an implementation bug, please report it.";
    throw IllegalStateException().o(toString(message));
  }
  if (consumed._v === limit) {
    if (limit === 9223372036854775807n)
      throw TooLongLineException().k4k('Max line length exceeded');
    var tmp_6;
    if (get_remaining(readBuffer) === 0n) {
      var tmp_7 = _this__u8e3s4.q4j(VOID, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      tmp_6 = !tmp_7;
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      throwEndOfStreamException(consumed._v);
    }
    var tmp0_subject = readBuffer.y3x().v3w(0n);
    if (tmp0_subject === 10) {
      discard(readBuffer, 1n);
      return consumed._v;
    } else if (tmp0_subject === 13) {
      var tmp_8 = internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      if (tmp_8)
        return consumed._v;
    }
    throwTooLongLineException(limit);
  }
  if (throwOnIncompleteLine) {
    throwEndOfStreamException(consumed._v);
  }
  return consumed._v;
}
function internalReadLineTo(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_internalReadLineTo__5n8dpi.bind(VOID, _this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine), $completion);
}
function throwEndOfStreamException(consumed) {
  throw EOFException().x4e('Unexpected end of stream after reading ' + consumed.toString() + ' characters');
}
function throwTooLongLineException(limit) {
  throw TooLongLineException().k4k('Line exceeds limit of ' + limit.toString() + ' characters');
}
function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.m4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function internalReadLineTo$transferString(readBuffer, $out, consumed, count) {
  if (count > 0n) {
    var string = readString(readBuffer, count);
    $out.t2(string);
    var tmp0 = consumed._v;
    // Inline function 'kotlin.Long.plus' call
    var other = string.length;
    consumed._v = add(tmp0, fromInt(other));
  }
}
function internalReadLineTo$scanForSoleCr(_this__u8e3s4, $lenientLineEnding, lfIndex, limitLeft) {
  if (!$lenientLineEnding)
    return -1n;
  var tmp;
  if (lfIndex === -1n) {
    // Inline function 'kotlin.Long.minus' call
    var this_0 = get_remaining(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = subtract(this_0, fromInt(1));
    tmp = limitLeft <= b ? limitLeft : b;
  } else if (lfIndex === 0n) {
    tmp = 0n;
  } else {
    // Inline function 'kotlin.Long.minus' call
    tmp = subtract(lfIndex, fromInt(1));
  }
  var endIndex = tmp;
  return indexOf(_this__u8e3s4, 13, VOID, endIndex);
}
function *_generator_internalReadLineTo$discardCrlfOrCr__fwcpdd(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion) {
  var tmp;
  var tmp_0;
  if (get_remaining(_this__u8e3s4) >= 2n) {
    tmp_0 = true;
  } else {
    var tmp_1 = $this_internalReadLineTo.p4j(2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  if (tmp_0) {
    tmp = _this__u8e3s4.y3x().v3w(1n) === 10;
  } else {
    tmp = false;
  }
  if (tmp) {
    discard(_this__u8e3s4, 2n);
    return true;
  }
  if ($lenientLineEnding) {
    discard(_this__u8e3s4, 1n);
    return true;
  }
  return false;
}
function internalReadLineTo$discardCrlfOrCr(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_internalReadLineTo$discardCrlfOrCr__fwcpdd.bind(VOID, _this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding), $completion);
}
//region block: exports
export {
  copyTo as copyTo3z8um8xkg7g1,
  readAvailable_0 as readAvailable3vfomv92cg41a,
  readLineStrictTo as readLineStrictTo28itb6tlpz7zv,
  readPacket as readPacket1r77mz431qe8y,
  readRemaining as readRemaininghtnrfi4c8vp0,
  readUntil as readUntil3k1nh8lpn23ao,
  skipIfFound as skipIfFound1m8ofwnay4fp9,
  toByteArray as toByteArray2f7h1d87fvkuc,
  rethrowCloseCauseIfNeeded as rethrowCloseCauseIfNeededeln8lm5agg4u,
  rethrowCloseCauseIfNeeded_1 as rethrowCloseCauseIfNeeded2q8fs9csuucwc,
};
//endregion

//# sourceMappingURL=ByteReadChannelOperations.mjs.map
